import { render, staticRenderFns } from "./ImageProcessingDialog.vue?vue&type=template&id=cf966694&scoped=true&"
import script from "./ImageProcessingDialog.vue?vue&type=script&lang=js&"
export * from "./ImageProcessingDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImageProcessingDialog.vue?vue&type=style&index=0&id=cf966694&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf966694",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QBtnGroup,QBtn,QSeparator,QSpinnerFacebook});
